import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import * as $ from 'jquery';
import { ModulosListComponent } from './modulos-list.component';
import { IModulo } from './modulo';
import { ModulosService } from './modulos.service';
import { errorMessageFromAjax } from '../services/ajax-error';
import * as myGlobals from './../global';

@Component({
  selector: 'pm-modulos',
  templateUrl: './modulos.component.html',
  styleUrls: ['./modulos.component.sass']
})
export class ModulosComponent implements OnInit, AfterViewInit, OnDestroy {
  modulos: IModulo[] = [];
  errorMessage = '';
  constructor(public service: ModulosService, private parent: ModulosListComponent) {}

  ngAfterViewInit() {
    $('a[rel=modulos]').addClass('selected');
  }

  newModulo(): void {
    this.parent.showEditModulo = false;
    this.parent.showModulos = false;
    this.parent.showAddModulo = true;
  }
  ngOnInit(): void {
    this.service
      .getModulos()
      .subscribe(modulos => (this.modulos = modulos), error => (this.errorMessage = error as any));
  }
  borrar(elemento, index: number) {
    console.log('index:' + index);
    $.ajax({
      url: myGlobals.baseApi + '/api/modulos/' + elemento.modulos[0].id,
      type: 'DELETE'
    }).done(function(response) {
      //
      console.log('delete sucess!!');
    }).fail(function(jqXHR) {
      alert('No se pudo eliminar el modulo: ' + errorMessageFromAjax(jqXHR));
    });
  }
  edit(elemento, index: number) {
    console.log('editarModulo' + elemento.modulos[index].id);
    this.parent.editnumber = elemento.modulos[index].id;
    this.parent.showModulos = false;
    this.parent.showAddModulo = false;
    this.parent.showEditModulo = true;
  }

  ngOnDestroy() {
    $('a[rel=modulos]').removeClass('selected');
  }
}
